import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";
import swal from "sweetalert2";
import { Router } from "@angular/router";

// import { generalModel, icons, menu, BtnText, permission, tabArray, optionArray } from '../shared/models/general.model';
import { Subject } from "rxjs";
import { apiUrl } from "../global/global";
// import { apiUrl } from "../global/global";

@Injectable({
  providedIn: "root",
})
export class AdminService {
  apiEndpoint: string = "";
  showLoader: boolean = true;
  access_token: any;
  // icon = icons;
  // menu = menu;
  // btnText = BtnText;
  // generalModel = new generalModel();
  // Permission = permission;
  public _albums = [];
  constructor(private http: HttpClient, private router: Router) {
    // console.log(environment, "environment");
    this.apiEndpoint = (environment as any).apiUrl;
    this.access_token = localStorage.getItem("adminToken");
  }

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };
  getData(url: any, param: any) {
    return this.http.get<any>(this.apiEndpoint + url, { params: param });
  }
  getDataByURL(url: any) {
    return this.http.get<any>(this.apiEndpoint + url);
  }

  getDetailByidParams(data: any, url: any, param = {}) {
    return this.http.get<any>(this.apiEndpoint + url + data.id, {
      params: param,
    });
  }
  getDetail(url: any, param: any) {
    return this.http.get<any>(this.apiEndpoint + url, { params: param });
  }

  getDetailByid(data: any, url: any) {
    return this.http.get<any>(this.apiEndpoint + url + data.id, {});
  }
  putData(url: any, param: any) {
    return this.http.put<any>(this.apiEndpoint + url, param);
  }
  postData(url: any, value: any) {
    return this.http.post<any>(this.apiEndpoint + url, value);
  }

  httpOptions1 = {
    headers: new HttpHeaders().set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    ),
  };
  postDataNew(url: any, value: any) {
    return this.http.post<any>(
      this.apiEndpoint + url,
      value.toString(),
      this.httpOptions1
    );
  }
  putDataNew(url: any, value: any) {
    return this.http.put<any>(
      this.apiEndpoint + url,
      value.toString(),
      this.httpOptions1
    );
  }

  upateData(url: any, value: any) {
    return this.http.put<any>(this.apiEndpoint + url, value);
  }
  patchUpdate(url: any, value: any) {
    return this.http.patch<any>(this.apiEndpoint + url, value);
  }
  postUpdate(url: any, value: any) {
    return this.http.put<any>(this.apiEndpoint + url, value);
  }

  postNewData(url: any, key: any, value: any) {
    return this.http.post<any>(this.apiEndpoint + url, key, value);
  }
  updateData(url: any, value: any) {
    return this.http.patch<any>(this.apiEndpoint + url, value);
  }

  // deleteData(url, value) {
  //   return this.http.delete<any>(this.apiEndpoint +url, value);
  // }

  deleteData(url: any, param: any) {
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      body: param,
    };
    return this.http.delete<any>(this.apiEndpoint + url, options);
  }

  showAlert(title: string, text: string) {
    swal.fire({
      title: '<figure><img src="../../assets/images/succes.png"></figure>',
      text: text,
      showConfirmButton: true,
      confirmButtonText: "Okay",
      confirmButtonColor: "#2FC863",
      timer: 1500,
    });
  }

  showError(title: string, text: string, confirmButtonText: string) {
    swal.fire({
      text: text,
      showConfirmButton: true,
      confirmButtonText: "Okay",
      confirmButtonColor: "#ff0000",
      timer: 1500,
    });
  }

  errorAlert(text: any, status: any, heading: any) {
    swal
      .fire({
        title: heading || "Oops...",
        text: text,
      })
      .then((result) => {
        if (status) {
          this.putData(apiUrl._logout, {}).subscribe(
            async (res) => {
              localStorage.removeItem("adminToken");
              localStorage.removeItem("adminDetail");
              localStorage.removeItem("firstName");
              localStorage.removeItem("lastName");
              localStorage.removeItem("image");
              localStorage.removeItem("s3Url");
              localStorage.removeItem("s3Folders");
              localStorage.removeItem("baseUrl");
              localStorage.removeItem("phoneNumber");
              localStorage.removeItem("fcmToken");
              localStorage.removeItem("userPermissions");
              localStorage.removeItem("userName");
              localStorage.removeItem("adminType");
              this.router.navigate(["/"]);
            },
            (err) => {
              // console.log(err, "errr");
            }
          );
        }
      });
  }

  // Show and hide Loader
  private loaderSubject = new Subject<Boolean>();
  loaderState = this.loaderSubject.asObservable();

  loader(value: any) {
    this.loaderSubject.next(value);
  }

  // setdata(data) {
  //   for (let x of tabArray) {
  //     let array1 = {}
  //     for (let y of x.value) {
  //       array1[optionArray[y].name] = (data[x.name] == undefined || data[x.name][optionArray[y].name] == undefined ? false : data[x.name][optionArray[y].name]);
  //     }
  //     permission[x.name] = array1;
  //   }
  //   permission['status'] = "updated";
  //   return true;
  // }
}
